export default function (element, data) {
    
element.addEventListener("click", function (e) {
        e.stopPropagation();
    });
}
